





















import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/svg/Logo.vue';
import WebFooter from '@/components/website/Footer.vue';
import WebNavigation from '@/components/website/Navigation.vue';

@Component({
  components: {
    WebFooter,
    WebNavigation,
    Logo,
  },
})
export default class Website extends Vue {
    scrollPosition: number|null = null;

    maxScrollPosition: number|null = null;

    stickyHeader = false;

    get classes() {
      return {
        'not-at-top': this.scrollPosition > 30,
        'sticky-header': this.stickyHeader,
      };
    }

    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    }

    updateScroll() {
      this.scrollPosition = window.scrollY;
      this.$nextTick(() => {
        if (this.maxScrollPosition < this.scrollPosition) {
          this.maxScrollPosition = this.scrollPosition;
          this.stickyHeader = false;
        } else if (this.scrollPosition < (this.maxScrollPosition - 50)) {
          this.maxScrollPosition = this.scrollPosition;
          this.stickyHeader = true;
        }
      });
    }

    destroy() {
      window.removeEventListener('scroll', this.updateScroll);
    }
}
